export default __webpack_public_path__ + "c0032ec9897326b9e65eeb216209d2d8.png";